export const MENTORSHIP_GOALS = [
    { value: "no_disclose", label: "I prefer not to share my goal." },
    { value: "student_help", label: "Support with my studies as a student." },
    { value: "career_start", label: "Guidance on starting my career after graduation." },
    { value: "career_change", label: "Help with changing careers or finding a new job." },
    { value: "skillset_enhance", label: "Improvement or expansion of my current skillset." },
    { value: "personal_project", label: "Mentorship for progressing with a personal project." },
    { value: "business_mentorship", label: "Guidance for developing my business or product." },
  ] as const;
